import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, ref } from 'vue'
import { ControlPosition, IControl, Map } from 'mapbox-gl'
import { Icon } from '@iconify/vue2'
import { useMapBox } from './composables/useMapBox'


export default /*#__PURE__*/_defineComponent({
  __name: 'MapBoxFullscreenControl',
  props: {
    position: null
  },
  setup(__props: any) {

const props = __props as {
	position?: ControlPosition
};



let control: IControl | undefined

const fullscreenButton = ref<HTMLElement>()
const isFullscreen = ref(false)

const { map } = useMapBox()

function toggleFullscreen() {
	const container = map?.value?.getContainer()?.parentElement
	if (!container) return

	if (!document.fullscreenElement) {
		container.requestFullscreen()
	} else {
		document.exitFullscreen()
	}
}

function onFullscreenChange() {
	isFullscreen.value = !!document.fullscreenElement
}

onMounted(() => {
	document.addEventListener('fullscreenchange', onFullscreenChange)

	let container: HTMLDivElement

	control = {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		onAdd(_map: Map) {
			container = document.createElement('div')
			container.className = 'mapboxgl-ctrl'

			fullscreenButton.value?.addEventListener('click', toggleFullscreen)

			container.appendChild(fullscreenButton.value!)

			return container
		},
		onRemove() {
			container?.remove()
		},
	}

	map?.value?.addControl(control!, props.position || 'top-right')
})

onUnmounted(() => {
	document.removeEventListener('fullscreenchange', onFullscreenChange)
	if (control) map?.value?.removeControl(control)
})

return { __sfc: true,props, control, fullscreenButton, isFullscreen, map, toggleFullscreen, onFullscreenChange, Icon }
}

})